<template>
  <img
    v-if="icon"
    :src="require(`../../assets/icons/i_${icon}.svg`)"
    class="icon"
    alt="image description"
  />
</template>

<script>
export default {
  name: "Icon",

  props: {
    icon: {
      type: String,
      default: null,
    },
  },
};
</script>

<style lang="scss" scoped>
.icon {
  display: inline-block;
  vertical-align: top;
}
</style>
